import * as Yup from "yup";


export const DispatchSchema = Yup.object({
    name: Yup.string().required('Enter Dispatch Name'),
    address:Yup.string().required('Enter Dispatch Address'),
    city:Yup.object().typeError('Select Dispatch City').required('Select Dispatch City'),
    city_name: Yup.string().when('city', {
        is: (val) => val?.value == 0,
        then: () => Yup.string().required("Enter City Name"),
        otherwise: () => Yup.string()
      }),
    gst_no: Yup.string().required(' Enter Dispatch GST No.'),
    pin_code: Yup.string().required('Enter Dispatch Pin Code'),
    cust_po_date: Yup.string().required('Select Customer PO Date'),
    cust_purchase_order: Yup.string().required('Enter Cust PO Number'),
    // customer_typ: Yup.string().required('Select Customer Type'),
    // so_type: Yup.string().required('Select SO Type'),
    // csale_typ: Yup.string().required('Select Order Type'),
    // remark: Yup.string().required('Enter Remark'),
}) 